import React from 'react'
import Link from 'next/link'
import { observer } from 'mobx-react-lite'
import FeedSubscriptionsStore from 'stores/feed-subscriptions'
import { useStore } from 'hooks'

const FavoritesDisplayNavOption = ({ type, data }) => {
  if (!data) return null
  const { name, image_url, url } = data
  return (
    <>
      <Link href={type === 'brand' ? '/shows/[slug]' : '/bio/[id]/[slug]'} as={url}>
        <a title={name} className='favoritesIcon' />
      </Link>
      <style jsx>{`
        .favoritesIcon {
          cursor: pointer;
          background-image: url('${image_url}');
          display: block;
          width: 2.5rem;
          height: 2.5rem;
          margin-right: 0.5rem;
          background-color: #f1f1f1;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: 50%;
          border-radius: 50%;
          flex-shrink: 0;
        }
      `}</style>
    </>
  )
}

const FavoritesDisplayNav = () => {
  const feedSubscriptionsStore = useStore(FeedSubscriptionsStore)
  return (
    <>
      <nav className='favoritesDisplayNav'>
        {feedSubscriptionsStore.items.map((favorite, index) => (
          <FavoritesDisplayNavOption {...favorite} key={index} />
        ))}
        <Link href='/account/favorites'>
          <a>Edit</a>
        </Link>
      </nav>
      <style jsx>{`
        .favoritesDisplayNav {
          padding: 0 1rem;
          margin: 0 0 1rem;
          display: inline-flex;
          align-items: center;
          max-width: 100%;
          overflow: scroll;
        }
        .favoritesDisplayNav a,
        .favoritesDisplayNav a:hover {
          color: #367dc4;
          display: block;
          font-size: 0.75rem;
          margin-left: 0.5rem;
          text-decoration: none;
          cursor: pointer;
        }
      `}</style>
    </>
  )
}

export default observer(FavoritesDisplayNav)
